import { ListingItem } from '../../../components';
import { APIListingItem } from '../types';
import { mapAuctionData } from './mapAuctionData';
import { mapAuctionStatus } from './mapAuctionStatus';
import { mapListingActions } from './mapListingActions';
import { mapListingNotification } from './mapListingNotification';
import { mapListingType } from './mapListingType';
import { mapReserveStatus } from './mapReserveStatus';
import { mapTimingData } from './mapTimingData';

export function mapAPIListing(apiListing: APIListingItem) {
  const type = mapListingType(apiListing.subStatus);
  return {
    id: apiListing.listingSku,
    type,
    auctionState: mapAuctionStatus(apiListing.status),
    imageUrl: apiListing.imageUrl,
    label: apiListing.badge,
    labelIcon: type === 'referred' ? 'Info' : undefined,
    labelAction: type === 'referred' ? 'ReferredInfoModal' : undefined,
    statusData:
      apiListing.notification &&
      mapListingNotification(apiListing.notification),
    auctionContext: {
      referenceNumber: apiListing.referenceNumber,
      auctionUrl: apiListing.listingUrl,
      title: apiListing.title,
      reserveText: apiListing.reservePriceText,
      reserve: apiListing.reservePrice,
      reserveStatus: mapReserveStatus(apiListing),
      auctionData: mapAuctionData(apiListing),
      quantity: apiListing.totalQuantity,
    },
    timingData: mapTimingData(apiListing),
    price: apiListing.price,
    priceText: apiListing.priceText,
    actions: mapListingActions(apiListing),
  } as ListingItem;
}
